// extracted by mini-css-extract-plugin
export var phone = "_13-0";